export const AddIcon = ({ className }: { className?: string }) => {
  return (
    <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.99984 4.16666V15.8333M4.1665 10H15.8332" stroke="#344054" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  );
};

AddIcon.displayName = "AddIcon";
